<template>
    <div>
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Import TAZ Data</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text dense>
                <v-layout row>
                    <!-- <v-flex xs4 body-2 pt-1></v-flex> -->
                    <v-flex xs12 text-xs-center pt-1>
                        <v-btn @click="onImport" large color="primary">Import TAZ Data</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs4 body-2 pt-1>Result:</v-flex>
                    <v-flex xs8 text-xs-left pt-1 >
<pre>
    {{ logMsg }}
</pre>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            logMsg: null
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('adminUser', [
            'importTazData',
        ]),
        async onImport() {
            if(confirm('Are you sure to import TAZ data to webquote?')) {
                this.logMsg = await this.importTazData()

            }
        }
    },
    async created() {
    },
}
</script>

